import React from 'react'
import styles from "../../common/DownloadApp/DownloadApp.module.scss";
import Srcset from '../Srcset';
import Link from 'next/link';

const DownloadApp = () => {
  return (
  <div className={`${styles.dowloadApp_wrapper}`}>
    <div className={`${styles.message_wrapper}`}>
    <p className={`x-small-md xx-small-sm x-small-xs ${styles.message}`}>
          Shop anywhere, anytime with the App
        </p>
    </div>
    <div className={`${styles["button-group"]}`}>  
      <Link href="https://apps.apple.com/us/app/olivela-fashion/id6498630359" tabIndex={0}>
          <Srcset
            src="images/Icons/Dowload_app.svg"
            height="50"
            width="150"
            alt="Download app"
            dataga4={"Footer - App Download"}
            svgFile={true}
            requirePath={true}
            className={"ga-footer-download"}
          />
      </Link>
    </div>
    </div>
  )
}

export default DownloadApp